<div class="container">
    <div class="card p-3">
        <h4>{{ textDisplay }}</h4>

        <form>
            <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
                <p>{{ modelError }}</p>
            </div>

            <div class="row">
                <div class="mb-3 col">
                    <label class="form-label">Name</label>
                    <input class="form-control" type="text" [(ngModel)]="questionBank.name"
                        [ngModelOptions]="{ standalone: true }" />
                </div>
            </div>

            <div class="row">
                <div class="mb-3 col">
                    <label class="form-label">Description</label>
                    <textarea class="form-control" rows="2" [(ngModel)]="questionBank.description"
                        [ngModelOptions]="{ standalone: true }"></textarea>
                </div>
            </div>

            <div class="row" *ngIf="isQbCompany">
                <div class="col">
                    <div class="custom-control custom-checkbox">
                        <input id="psychometricQuestionBank" type="checkbox" class="custom-control-input"
                            [(ngModel)]="questionBank.isPsychometricTestBank" [ngModelOptions]="{ standalone: true }"
                            (change)="onPsychometricChange()">
                        <label class="custom-control-label" for="psychometricQuestionBank">Psychometric Question
                            Bank</label>
                    </div>
                </div>
            </div>

            <div class="row mt-2" *ngIf="questionBank.isPsychometricTestBank">
                <label class="form-label">Upload Questions JSON</label>
                <div class="col-md-8 mb-3">

                    <input type="file" accept=".json" class="form-control" (change)="handleJsonUpload($event)" />

                    <small *ngIf="uploadedJsonFileName" class="text-success mt-1">
                        Selected: {{ uploadedJsonFileName }}
                    </small>
                </div>
                <div class="col-md-4 mb-3 d-flex align-items-end flex-column">
                    <button *ngIf="!uploadedJsonFileName" class="btn btn-outline-primary w-100"
                        (click)="downloadSampleJson()">
                        Download Sample JSON
                    </button>

                    <button *ngIf="uploadedJsonFileName || (isSave === false && questionBank.questionsJson !== '')" class="btn btn-outline-info w-100" (click)="openJsonModal()">
                        View Uploaded JSON
                    </button>
                </div>
            </div>

            <div class="row mt-2">
                <div class="mb-3 col">
                    <label class="form-label">Question Type</label>
                    <ng-select class="form-select form-control" [(ngModel)]="questionBank.questionType"
                        [disabled]="questionBank.isPsychometricTestBank" [ngModelOptions]="{ standalone: true }">
                        <ng-option selected value="" disabled>Select Type</ng-option>
                        <ng-option *ngFor="let type of questionTypes" [value]="type.value">
                            {{ type.label }}
                        </ng-option>
                    </ng-select>
                    <small *ngIf="questionBank.isPsychometricTestBank" class="text-muted">
                        Question Type is automatically set to "Multiple-Choice"
                    </small>
                </div>
            </div>

            <div class="row" *ngIf="questionBank.id > 0">
                <div class="col">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="questionBank.disabled"
                            [ngModelOptions]="{ standalone: true }" />
                        <label class="form-check-label">Disable Question Bank</label>
                    </div>
                </div>
            </div>

            <hr />

            <div class="row mt-3">
                <div class="col" *ngIf="!isSave">
                    <input class="form-control bg-primary text-white" type="button" value="Update Question Bank"
                        (click)="saveQuestionBank(true)" />
                </div>
                <div class="col" *ngIf="isSave">
                    <input class="form-control bg-primary text-white" type="button" value="Save Question Bank"
                        (click)="saveQuestionBank()" />
                </div>
                <div class="col" *ngIf="isSave">
                    <input class="form-control bg-secondary text-white" type="button" value="Cancel"
                        (click)="goBack()" />
                </div>
            </div>
        </form>
    </div>
</div>

<ng-template #jsonModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Uploaded JSON Preview</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body json-preview-body">
        <pre>{{ prettyJson }}</pre>
    </div>

    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="modal.close()">Close</button>
    </div>
</ng-template>